import { EventSnapshot, Market } from '../api/types';

export function mergeSnapshotWithPatch(oldEv: EventSnapshot, message: any): EventSnapshot {
  const merged = { ...oldEv };
  
  if (message.patch) {
    // Merge patch
    if (message.patch.event) {
      merged.event = { ...oldEv.event, ...message.patch.event };
    }
    if (message.patch.status) {
      merged.status = { ...oldEv.status, ...message.patch.status };
    }
    
    let currentMarkets = oldEv.markets || [];
    
    // Handle patch.markets.delete
    if (message.patch.markets && Array.isArray(message.patch.markets.delete)) {
      const deleteKeys = new Set(message.patch.markets.delete);
      currentMarkets = currentMarkets.filter(
        m => !deleteKeys.has(m.canonical_key) && !deleteKeys.has(m.market_id)
      );
    }
    
    // Handle patch.markets.upsert
    if (message.patch.markets && Array.isArray(message.patch.markets.upsert)) {
      const marketMap = new Map(currentMarkets.map(m => [m.canonical_key || m.market_id, m]));
      for (const m of message.patch.markets.upsert) {
        marketMap.set(m.canonical_key || m.market_id, m);
      }
      currentMarkets = Array.from(marketMap.values());
    }
    
    merged.markets = currentMarkets;
    if (message.version) {
      merged.version = message.version;
    }
  } else {
    // If it's a full snapshot instead of a patch
    if (message.event) merged.event = { ...oldEv.event, ...message.event };
    if (message.status) merged.status = { ...oldEv.status, ...message.status };
    if (message.version) merged.version = message.version;
    
    if (message.markets && Array.isArray(message.markets)) {
      const marketMap = new Map((oldEv.markets || []).map(m => [m.canonical_key || m.market_id, m]));
      for (const m of message.markets) {
        marketMap.set(m.canonical_key || m.market_id, m);
      }
      merged.markets = Array.from(marketMap.values());
    }
  }
  
  return merged;
}

export function applyStreamUpdates(upserts: EventSnapshot[], deletes: string[], onlyExisting = false) {
  return (prev: EventSnapshot[] | null): EventSnapshot[] | null => {
    if (!prev) return null;
    if (upserts.length === 0 && deletes.length === 0) return prev;
    
    let next = [...prev];
    let changed = false;

    if (deletes.length > 0) {
      const deleteSet = new Set(deletes);
      const filtered = next.filter(ev => !deleteSet.has(ev.event_id));
      if (filtered.length !== next.length) {
        next = filtered;
        changed = true;
      }
    }

    if (upserts.length > 0) {
      for (const ev of upserts) {
        const idx = next.findIndex(p => p.event_id === ev.event_id);
        if (idx > -1) {
          next[idx] = ev;
          changed = true;
        } else if (!onlyExisting) {
          next.push(ev);
          changed = true;
        }
      }
    }

    return changed ? next : prev;
  };
}
